import React from "react";
import styles from "./CartHeader.module.css";
import cartIcon from "./Group 17195.svg";

const CartHeader = ({ numOfItems }) => {
  const PluralItems = (num) => {
    if (num === 1) {
      return <>Your Cart Has {num} Item</>;
    } else {
      return <>Your Cart Has {num} Items</>;
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>{PluralItems(numOfItems)}</div>
      <div className={styles.img}>
        <img className={styles.cartIcon} src={cartIcon} alt="Shopping Cart" />
      </div>
    </div>
  );
};

export default CartHeader;
